var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _path8, _path9, _path0, _path1, _path10, _g6, _path11, _path12, _g7, _path13, _path14, _g8, _path15, _g9, _path16, _g0, _path17, _g1, _path18, _g10, _path19, _path20, _path21, _path22, _path23, _g11, _path24, _path25, _g12, _path26, _g13, _path27, _g14, _path28, _path29, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGroupBackgroundIndicacao = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 89,
    viewBox: "0 0 187 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M185.791 44.5952L182.017 34.6904C181.309 32.8333 179.717 31.4478 177.83 30.9467L179.746 14.4387C180.159 10.8718 179.009 7.30494 176.562 4.68136C174.115 2.05778 170.635 0.642814 167.067 0.760728L21.3478 6.9512C17.3082 7.12807 13.534 9.01469 10.9688 12.1099C8.55092 15.0578 7.37148 18.831 7.7548 22.6337H5.83821H5.57284C5.48438 22.6337 5.42542 22.6337 5.33696 22.6337H4.77672C2.15247 22.6337 0.0294877 24.7562 0.0294877 27.3798V34.7789H0.117942V51.0215C0.0294841 51.3457 0 51.67 0 52.0238V59.5702C0 61.5748 1.62172 63.1961 3.62677 63.1961H5.63182C6.63434 63.1961 7.57789 62.7834 8.25606 62.0759C8.93424 62.7834 9.8483 63.1961 10.8803 63.1961H12.8854C13.1507 63.1961 13.4161 63.1666 13.6815 63.1077C13.8584 63.1371 14.0648 63.1666 14.2417 63.1961L14.684 64.1394C17.4557 70.0351 23.2054 74.1326 29.6923 74.8401L156.895 88.6655C157.278 88.6949 157.661 88.7244 158.045 88.7539C158.163 88.7539 158.31 88.7539 158.428 88.7539C165.564 88.7539 171.785 83.212 172.611 76.1371L175.707 49.6065H181.014H181.162C181.191 49.6065 181.221 49.6065 181.25 49.6065H182.4C182.518 49.6065 182.665 49.6065 182.783 49.577H182.813C183.874 49.4591 184.847 48.899 185.437 48.0147C186.056 46.9829 186.204 45.7154 185.791 44.5952Z",
    fill: "url(#paint0_linear_20693_23008)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20693_23008",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 187,
    height: 89
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M186.027 0.790039H0.0297852V88.7243H186.027V0.790039Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20693_23008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.1896 28.7357C6.04469 28.7357 6.39851 28.2935 6.39851 27.704C6.39851 27.0554 5.98571 26.7017 5.27805 26.7017H4.18707V28.7357H5.1896ZM3.56787 26.1416H5.36651C6.57543 26.1416 7.0767 26.8196 7.0767 27.7334C7.0767 28.8241 6.33955 29.3253 5.27805 29.3253H4.21656V31.2709H3.59735V26.1416H3.56787Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_20693_23008",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 187,
    height: 89
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M186.027 0.790039H0.0297852V88.7243H186.027V0.790039Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_20693_23008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.64199 28.7357C10.4971 28.7357 10.8509 28.2935 10.8509 27.704C10.8509 27.0554 10.4381 26.7017 9.70097 26.7017H8.60998V28.7357H9.64199ZM8.02026 26.1416H9.8484C11.0278 26.1416 11.5586 26.8196 11.5586 27.7334C11.5586 28.5883 11.0868 29.0894 10.2907 29.2663L11.706 31.2709H10.9394L9.58302 29.3253H8.66896V31.2709H8.04975V26.1416H8.02026Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_20693_23008",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 187,
    height: 89
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M186.027 0.790039H0.0297852V88.7243H186.027V0.790039Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_20693_23008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.748 28.7056C16.748 27.5265 15.9224 26.6716 14.8314 26.6716C13.7109 26.6716 12.9148 27.5265 12.9148 28.7056C12.9148 29.8553 13.7404 30.7102 14.8314 30.7102C15.8929 30.7102 16.748 29.8848 16.748 28.7056ZM12.2661 28.7056C12.2661 27.1727 13.3571 26.082 14.8609 26.082C16.3057 26.082 17.4262 27.1433 17.4262 28.7056C17.4262 30.268 16.3057 31.3292 14.8609 31.3292C13.3571 31.2997 12.2661 30.209 12.2661 28.7056Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_20693_23008",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 187,
    height: 89
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M186.027 0.790039H0.0297852V88.7243H186.027V0.790039Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_20693_23008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2224 28.7056C18.2224 27.1727 19.2249 26.082 20.7582 26.082C21.4659 26.082 22.1735 26.3179 22.7043 26.878L22.262 27.2612C21.8492 26.8779 21.3479 26.6716 20.7287 26.6716C19.6377 26.6716 18.8416 27.4675 18.8416 28.7056C18.8416 29.8848 19.6083 30.7102 20.7582 30.7102C21.2595 30.7102 21.7312 30.5628 22.1146 30.2975V29.1773H20.6108V28.6172H22.7338V30.6512C22.262 31.0639 21.5248 31.2997 20.7287 31.2997C19.3429 31.2997 18.2224 30.2975 18.2224 28.7056Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_20693_23008",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 187,
    height: 89
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M186.027 0.790039H0.0297852V88.7243H186.027V0.790039Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_20693_23008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6234 28.7357C26.4785 28.7357 26.8323 28.2935 26.8323 27.704C26.8323 27.0554 26.4195 26.7017 25.6824 26.7017H24.5914V28.7357H25.6234ZM23.9722 26.1416H25.8003C26.9797 26.1416 27.5105 26.8196 27.5105 27.7334C27.5105 28.5883 27.0387 29.0894 26.2426 29.2663L27.6579 31.2709H26.8913L25.5349 29.3253H24.6209V31.2709H24.0017V26.1416H23.9722Z",
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3731 29.4727L30.4296 26.908L29.486 29.4727H31.3731ZM30.1053 26.1416H30.7245L32.6705 31.2709H32.0218L31.5501 30.0328H29.2502L28.8079 31.2709H28.1592L30.1053 26.1416Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4961 26.1416H34.1448L36.0319 29.4432H36.0614L37.9485 26.1416H38.5677V31.2709H37.9485V27.3502H37.919L36.2383 30.2391H35.8255L34.1448 27.3502V31.2709H33.4961V26.1416Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.607 29.4727L41.6635 26.908L40.7199 29.4727H42.607ZM41.3391 26.1416H41.9583L43.9044 31.2709H43.2557L42.7839 30.0328H40.484L40.0418 31.2709H39.3931L41.3391 26.1416Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1013 34.2783H3.65649V46.0697H5.1013V34.2783Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10864 34.2783H9.52396L16.2173 43.6525V34.2783H17.6621V46.0697H16.1878L9.58294 36.784H9.55345V46.0697H8.10864V34.2783Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_20693_23008",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 187,
    height: 89
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M186.027 0.790039H0.0297852V88.7243H186.027V0.790039Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_20693_23008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0606 44.7727C26.9503 44.7727 28.7194 42.8566 28.7194 40.2035C28.7194 37.521 26.8618 35.6049 24.0901 35.6049H21.9966V44.7727H24.0606ZM20.5813 34.2783H24.1196C27.8643 34.2783 30.2527 36.6956 30.2527 40.2035C30.2527 43.6819 27.9528 46.0992 24.1786 46.0992H20.6108V34.2783H20.5813Z",
    fill: "white"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1743 34.2783H32.7295V46.0697H34.1743V34.2783Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_20693_23008",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 187,
    height: 89
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M186.027 0.790039H0.0297852V88.7243H186.027V0.790039Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_20693_23008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6804 40.2023C36.6804 36.8712 38.7739 34.1592 42.5481 34.1592C44.2583 34.1592 45.9095 34.8961 47.1479 36.429L46.0569 37.3134C45.0839 36.1048 43.875 35.5447 42.5186 35.5447C39.8354 35.5447 38.1547 37.4902 38.1547 40.2023C38.1547 43.0322 40.0418 44.8009 42.5186 44.8009C44.0519 44.8009 45.2019 44.0639 46.0569 43.0322L47.1479 43.946C46.1159 45.2136 44.6121 46.1864 42.5481 46.1864C39.3636 46.1569 36.6804 44.0639 36.6804 40.2023Z",
    fill: "white"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5514 41.9427L53.3695 36.0176H53.34L51.1875 41.9427H55.5514ZM52.6323 34.2783H54.0771L58.559 46.0697H57.0552L55.9937 43.2103H50.7157L49.6837 46.0697H48.1799L52.6323 34.2783Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_20693_23008",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 187,
    height: 89
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M186.027 0.790039H0.0297852V88.7243H186.027V0.790039Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_20693_23008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.0463 46.5989V46.6284C65.9308 46.6579 66.5206 47.1295 66.5206 47.9549C66.5206 48.6624 65.9603 49.2225 64.7514 49.2225C64.3386 49.2225 64.0732 49.1635 63.8078 49.1341V48.3971C64.0142 48.4561 64.2501 48.515 64.604 48.515C65.0757 48.515 65.5475 48.3381 65.5475 47.896C65.5475 47.5422 65.1052 47.1885 64.1617 47.1885L64.1912 46.6873L64.4271 46.1272C61.5964 45.803 59.3555 43.7395 59.3555 40.2316C59.3555 36.9005 61.449 34.1885 65.2232 34.1885C66.9334 34.1885 68.5846 34.9254 69.823 36.4583L68.732 37.3427C67.759 36.1341 66.55 35.574 65.1937 35.574C62.5105 35.574 60.8298 37.549 60.8298 40.2316C60.8298 43.0615 62.7169 44.8302 65.1937 44.8302C66.727 44.8302 67.8769 44.0932 68.732 43.0615L69.823 43.9753C68.791 45.2429 67.2872 46.2157 65.2232 46.2157L65.0463 46.5989Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_20693_23008",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 187,
    height: 89
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M186.027 0.790039H0.0297852V88.7243H186.027V0.790039Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_20693_23008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.2265 41.9426L76.0445 36.0174H76.015L73.8626 41.9426H78.2265ZM75.9266 32.539C75.5432 32.3032 75.1894 32.1263 74.8651 32.1263C74.4818 32.1263 74.1279 32.48 73.892 33.0401L73.0369 32.6864C73.3613 31.7431 73.9215 31.124 74.7766 31.124C75.3663 31.124 75.8086 31.3893 76.1919 31.6252C76.5458 31.8315 76.8701 32.0968 77.2534 32.0968C77.6073 32.0968 77.9316 31.8315 78.138 31.183L78.9931 31.4778C78.6688 32.5979 78.0495 33.1286 77.3124 33.1286C76.8111 33.0696 76.3688 32.8043 75.9266 32.539ZM75.3074 34.2782H76.7522L81.234 46.0696H79.7303L78.6688 43.2102H73.3908L72.3588 46.0696H70.855L75.3074 34.2782Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_20693_23008",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 187,
    height: 89
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M186.027 0.790039H0.0297852V88.7243H186.027V0.790039Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_20693_23008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.3209 40.1728C92.3209 37.4313 90.4043 35.5152 87.957 35.5152C85.3917 35.5152 83.5341 37.4902 83.5341 40.1728C83.5341 42.8258 85.3917 44.8009 87.957 44.8009C90.4043 44.8009 92.3209 42.8848 92.3209 40.1728ZM82.0303 40.1728C82.0303 36.6648 84.5366 34.1592 87.957 34.1592C91.2594 34.1592 93.8541 36.5764 93.8541 40.1728C93.8541 43.7692 91.2889 46.1569 87.957 46.1569C84.5071 46.1569 82.0303 43.6807 82.0303 40.1728Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_20693_23008",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 187,
    height: 89
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M186.027 0.790039H0.0297852V88.7243H186.027V0.790039Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_20693_23008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.498 40.2624C106.474 40.2624 107.299 39.2602 107.299 37.9042C107.299 36.4008 106.326 35.6049 104.734 35.6049H102.198V40.2624H104.498ZM100.753 34.2783H104.881C107.653 34.2783 108.774 35.8407 108.774 37.9337C108.774 40.4393 107.063 41.5595 104.616 41.5595H102.198V46.0697H100.753V34.2783Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_20693_23008",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 187,
    height: 89
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M186.027 0.790039H0.0297852V88.7243H186.027V0.790039Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_20693_23008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.73 40.2624C116.706 40.2624 117.531 39.2602 117.531 37.9042C117.531 36.4008 116.558 35.6049 114.936 35.6049H112.401V40.2624H114.73ZM110.956 34.2783H115.143C117.855 34.2783 119.035 35.8407 119.035 37.9337C119.035 39.9087 117.944 41.0584 116.086 41.4416L119.359 46.0697H117.62L114.494 41.5595H112.371V46.0697H110.926V34.2783H110.956Z",
    fill: "white"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M121.6 34.2783H128.854V35.5754H123.045V39.555H127.792V40.852H123.045V44.7727H129.178V46.0697H121.6V34.2783Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M131.448 34.2783H132.923L137.257 41.9132H137.286L141.621 34.2783H143.066V46.0697H141.621V37.0788H141.591L137.758 43.6819H136.785L132.952 37.0788H132.923V46.0697H131.448V34.2783Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M147.518 34.2783H146.073V46.0697H147.518V34.2783Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M156.865 41.9427L154.683 36.0176H154.654L152.501 41.9427H156.865ZM153.946 34.2783H155.391L159.873 46.0697H158.369L157.307 43.2103H152.029L150.997 46.0697H149.494L153.946 34.2783Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_20693_23008",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 187,
    height: 89
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M186.027 0.790039H0.0297852V88.7243H186.027V0.790039Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_20693_23008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.24 44.7727C168.129 44.7727 169.898 42.8566 169.898 40.2035C169.898 37.521 168.041 35.6049 165.269 35.6049H163.176V44.7727H165.24ZM161.76 34.2783H165.299C169.043 34.2783 171.432 36.6956 171.432 40.2035C171.432 43.6819 169.132 46.0992 165.358 46.0992H161.79V34.2783H161.76Z",
    fill: "white"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M179.57 41.9427L177.388 36.0176H177.358L175.206 41.9427H179.57ZM176.68 34.2783H178.125L182.607 46.0697H181.103L180.041 43.2103H174.763L173.731 46.0697H172.228L176.68 34.2783Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_20693_23008",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 187,
    height: 89
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M186.027 0.790039H0.0297852V88.7243H186.027V0.790039Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_20693_23008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4044 56.5038C21.0236 56.0027 21.4069 55.1773 21.4069 54.2929C21.4069 53.4675 21.112 52.7601 20.5223 52.1705C19.9326 51.5809 19.2249 51.2861 18.3993 51.2861H14.9495C14.5956 51.2861 14.3008 51.5809 14.3008 51.9641V59.5401C14.3008 59.5991 14.3598 59.658 14.4187 59.658H16.4238C16.4827 59.658 16.5417 59.5991 16.5417 59.5401V53.4381H18.3404C18.8121 53.4381 19.1365 53.8213 19.166 54.3814C19.166 54.6762 19.048 54.9415 18.8711 55.1478C18.6647 55.3542 18.4288 55.4426 18.1634 55.4426H17.3968C17.3378 55.4426 17.3083 55.4721 17.2789 55.5016C17.2494 55.531 17.2494 55.59 17.2789 55.6195L19.8146 59.6285C19.8441 59.658 19.8736 59.6875 19.9031 59.6875H22.0556C22.144 59.6875 22.203 59.5696 22.144 59.5106L20.2864 56.5923L20.4044 56.5038Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_20693_23008",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 187,
    height: 89
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M186.027 0.790039H0.0297852V88.7243H186.027V0.790039Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_20693_23008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.7121 55.5611L23.6481 51.4047C23.6186 51.3752 23.5891 51.3457 23.5302 51.3457H21.3187C21.2303 51.3457 21.1713 51.4341 21.2008 51.5226L25.0929 59.3638C25.2109 59.5702 25.4468 59.7176 25.6827 59.7176C25.948 59.7176 26.1544 59.5997 26.2724 59.3638L30.194 51.5226C30.2235 51.4341 30.1645 51.3457 30.0761 51.3457H27.8351C27.7762 51.3457 27.7467 51.3752 27.7172 51.4047L25.7121 55.5611Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_20693_23008",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 187,
    height: 89
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M186.027 0.790039H0.0297852V88.7243H186.027V0.790039Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_20693_23008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5612 51.3746C12.2958 51.2566 12.06 51.3156 11.8241 51.5219L8.25627 55.2657L4.71796 51.5514C4.48207 51.3451 4.2167 51.2861 3.95132 51.3746C3.68595 51.4925 3.50903 51.7283 3.50903 52.0231V59.5696C3.50903 59.6285 3.568 59.6875 3.62698 59.6875H5.63202C5.691 59.6875 5.74997 59.6285 5.74997 59.5696V55.8848L7.78449 58.0072C8.02038 58.243 8.43319 58.243 8.69856 58.0072L10.7331 55.8848V59.5696C10.7331 59.6285 10.7921 59.6875 10.851 59.6875H12.8561C12.9151 59.6875 12.974 59.6285 12.974 59.5696V52.0231C13.0035 51.7283 12.8266 51.463 12.5612 51.3746Z",
    fill: "white"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M167.244 5.35977C167.421 5.35977 167.598 5.35977 167.775 5.35977C169.839 5.41872 171.785 6.30308 173.2 7.80648C174.734 9.45727 175.471 11.6976 175.205 13.9085L173.053 32.3915C173.407 32.421 173.761 32.4799 174.115 32.5684L176.267 14.0559C176.562 11.4913 175.736 8.95614 173.997 7.06952C172.257 5.1829 169.78 4.18063 167.215 4.26906L21.5248 10.4595C18.4877 10.5775 15.6276 11.9924 13.6815 14.3507C11.7354 16.6795 10.8803 19.7747 11.3226 22.7815L11.6765 25.1103C12.0303 25.0514 12.3841 25.0219 12.7379 24.9924L12.3841 22.6047C12.0008 19.8926 12.7674 17.1217 14.5071 15.0287C16.2468 12.9062 18.8121 11.6387 21.5542 11.5208L167.244 5.35977Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M171.019 49.8721L168.011 75.5773C167.392 80.8539 162.615 84.6566 157.337 84.0966L30.1642 70.2712C25.1811 69.7405 20.9646 66.6158 18.8711 62.2825C18.5468 62.4299 18.1929 62.5478 17.8391 62.6362C20.08 67.3823 24.6209 70.7723 30.0463 71.3619L157.219 85.1873C157.514 85.2167 157.809 85.2462 158.104 85.2462C163.618 85.3936 168.424 81.2961 169.073 75.7247L172.08 49.9605C171.726 49.9605 171.372 49.931 171.019 49.8721Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20693_23008",
    x1: 0.0321692,
    y1: 44.7549,
    x2: 186.027,
    y2: 44.7549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0320414,
    stopColor: "#E97E05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#ED930E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4271,
    stopColor: "#F1A315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6642,
    stopColor: "#F2AC19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3AF1A"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGroupBackgroundIndicacao);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/group-background-indicacao.c7441c9389c6afee13759a2758d1bee7.svg";